import React from "react";
import { object, number } from "prop-types";
import { Link } from "@quintype/components";

import Headline from "../../atoms/headline";

import "./card-image-type-2-wo-image.m.css";

const CardImageType2WoImage = ({ story, headlineLimit }) => {
  const storyObj = story.story ? story.story : story;
  return (
    <Link href={`/${storyObj.slug}`}>
      <div styleName="wrapper" className="card-image-type-2">
        <Headline story={storyObj} headerType={3} headerLevel={2} headlineLimit={headlineLimit} />
      </div>
    </Link>
  );
};

export default CardImageType2WoImage;

CardImageType2WoImage.propTypes = {
  story: object,
  headlineLimit: number
};
